"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_TYPES = void 0;
var STATUS_TYPES = Object.freeze({
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error'
});
exports.STATUS_TYPES = STATUS_TYPES;